/*
 * @Description:
 * @version:
 * @Author: linziying
 * @Date: 2019-08-22 15:49:23
 * @LastEditors: ChenGuocai
 * @LastEditTime: 2021-03-04 14:24:35
 */
export default [
    {
        path: "/",
        name: "rootPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/download.vue"),
        meta: {
            title: "知屿-陪伴你的抉择",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/list",
        name: "liveListPage",
        component: () =>
            import(/* webpackChunkName: "live" */ "@/pages/live/liveList.vue"),
        meta: {
            title: "知屿",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/open_live",
        name: "liveIndexPage",
        component: () =>
            import(/* webpackChunkName: "live" */ "@/pages/live/index.vue"),
        meta: {
            title: "知屿",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/download",
        name: "downloadPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/download.vue"),
        meta: {
            title: "知屿-陪伴你的抉择",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/newDownload",
        name: "newDownloadPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/newDownload.vue"),
        meta: {
            title: "知屿-陪伴你的抉择",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/mllDownload",
        name: "mllDownloadPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/mllDownload.vue"),
        meta: {
            title: "知屿-陪伴你的抉择",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/yidaka",
        name: "yidakaDownloadPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/yidaka.vue"),
        meta: {
            title: "易大咖-老师端APP",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    // {
    // 	path: "/bag",
    // 	name: "bagPage",
    // 	component: () => import(/* webpackChunkName: "activity" */ "@/pages/activity/bag.vue"),
    // 	meta: {
    // 		title: "新人专享礼包",
    // 		keepAlive: false,
    // 		needLoginLjds: true,
    // 	},
    // },
    {
        //老师入驻流程
        path: "/applyStep1",
        name: "applyStep1",
        component: () =>
            import(/* webpackChunkName: "teacherApply" */ "@/pages/teacherApply/applyStep1.vue"),
        meta: {
            title: "老师入驻",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        //老师入驻流程
        path: "/applyStep2",
        name: "applyStep2",
        component: () =>
            import(/* webpackChunkName: "teacherApply" */ "@/pages/teacherApply/applyStep2.vue"),
        meta: {
            title: "老师入驻",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        //老师入驻流程
        path: "/applyStep3",
        name: "applyStep3",
        component: () =>
            import(/* webpackChunkName: "teacherApply" */ "@/pages/teacherApply/applyStep3.vue"),
        meta: {
            title: "老师入驻",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        //老师入驻流程
        path: "/applyStep4",
        name: "applyStep4",
        component: () =>
            import(/* webpackChunkName: "teacherApply" */ "@/pages/teacherApply/applyStep4.vue"),
        meta: {
            title: "老师入驻",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        //老师入驻流程
        path: "/applyService",
        name: "applyService",
        component: () =>
            import(/* webpackChunkName: "teacherApply" */ "@/pages/teacherApply/applyService.vue"),
        meta: {
            title: "老师入驻",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        //老师入驻流程
        path: "/infoForm",
        name: "infoForm",
        component: () =>
            import(/* webpackChunkName: "teacherApply" */ "@/pages/teacherApply/infoForm.vue"),
        meta: {
            title: "老师入驻",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        //老师入驻流程
        path: "/upFail",
        name: "upFail",
        component: () =>
            import(/* webpackChunkName: "teacherApply" */ "@/pages/teacherApply/upFail.vue"),
        meta: {
            title: "老师入驻",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        //老师入驻流程
        path: "/upSuccess",
        name: "upSuccess",
        component: () =>
            import(/* webpackChunkName: "teacherApply" */ "@/pages/teacherApply/upSuccess.vue"),
        meta: {
            title: "老师入驻",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        //老师入驻流程
        path: "/applyIndex",
        name: "applyIndex",
        component: () =>
            import(/* webpackChunkName: "teacherApply" */ "@/pages/teacherApply/applyIndex.vue"),
        meta: {
            title: "老师入驻",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        //老师入驻流程
        path: "/subject",
        name: "subject",
        component: () =>
            import(/* webpackChunkName: "teacherApply" */ "@/pages/teacherApply/subject.vue"),
        meta: {
            title: "老师入驻调查问券",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/teacherManage",
        name: "teacherManagePage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/teacherManage.vue"),
        meta: {
            title: "知屿老师管理公约",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/instructions",
        name: "instructionsPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/instructions.vue"),
        meta: {
            title: "知屿老师违规管理条例",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/teacherLive",
        name: "teacherLivePage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/teacherLive.vue"),
        meta: {
            title: "知屿老师直播管理规定",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/teacherViolation",
        name: "teacherViolationPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/teacherViolation.vue"),
        meta: {
            title: "知屿老师在线服务违规管理条例",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/teacherAppeal",
        name: "teacherAppealPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/teacherAppeal.vue"),
        meta: {
            title: "知屿直播违规申诉管理规定",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/protocolCenter",
        name: "protocolCenterPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/protocolCenter.vue"),
        meta: {
            title: "知屿老师规范",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    // {
    // 	path: "/mllLive",
    // 	name: "mllLivePage",
    // 	component: () => import(/* webpackChunkName: "activity" */ "@/pages/activity/mllLive.vue"),
    // 	meta: {
    // 		title: "知屿双11特辑",
    // 		keepAlive: false,
    // 		needLoginLjds: true,
    // 	},
    // },
    {
        path: "/liyiling",
        name: "liyiling",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/liyiling.vue"),
        meta: {
            title: "李易玲-您的私人起名师",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/msgDownload",
        name: "msgDownloadPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/messageDownload.vue"),
        meta: {
            title: "知屿-陪伴你的抉择",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    // {
    // 	path: "/bag148",
    // 	name: "bag148Page",
    // 	component: () => import(/* webpackChunkName: "activity" */ "@/pages/activity/bag148.vue"),
    // 	meta: {
    // 		title: "新人专享礼包",
    // 		keepAlive: false,
    // 		needLoginLjds: true,
    // 	},
    // },
    {
        // 知屿-实名认证
        path: "/teacherAuth",
        name: "teacherAuthPage",
        component: () =>
            import(/* webpackChunkName: "teacherApply" */ "@/pages/teacherApply/teacherAuth.vue"),
        meta: {
            title: "实名认证",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        // 知屿-电子签约
        path: "/teacherInfo",
        name: "teacherInfoPage",
        component: () =>
            import(/* webpackChunkName: "teacherApply" */ "@/pages/teacherApply/teacherInfo.vue"),
        meta: {
            title: "电子签约",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: true,
        },
    },
    {
        // 知屿-人脸验证结果
        path: "/faceAuthResult",
        name: "faceAuthResultPage",
        component: () =>
            import(/* webpackChunkName: "teacherApply" */ "@/pages/teacherApply/faceAuthResult.vue"),
        meta: {
            title: "人脸识别",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: true,
        },
    },
    {
        // 知屿-合作签约补充
        path: "/supplySign",
        name: "supplySignPage",
        component: () =>
            import(/* webpackChunkName: "teacherApply" */ "@/pages/teacherApply/supplySign.vue"),
        meta: {
            title: "合作签约补充",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: true,
        },
    },
    {
        // 知屿-身份证上传
        path: "/idCardUpload",
        name: "idCardUploadPage",
        component: () =>
            import(/* webpackChunkName: "teacherApply" */ "@/pages/teacherApply/idCardUpload.vue"),
        meta: {
            title: "身份证上传",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: true,
        },
    },
    // {
    //     path: '/2020year',
    //     name: '2020yearPage',
    //     component: () => import( /* webpackChunkName: "activity" */ '@/pages/activity/2020year/2020year.vue'),
    //     meta: {
    //         title: '2020新年活动',
    //         keepAlive: false,
    //         needLoginLjds: true,
    //     }
    // },
    // {
    //     path: '/2020year/order',
    //     name: 'orderList',
    //     component: () => import( /* webpackChunkName: "activity" */ '@/pages/activity/2020year/orderList.vue'),
    //     meta: {
    //         title: '2020新年活动领取记录',
    //         keepAlive: false,
    //         needLoginLjds: true,
    //     }
    // },
    {
        path: "/help",
        name: "help",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/help/index.vue"),
        meta: {
            title: "帮助中心",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/helpRules",
        name: "helpRules",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/help/helpRules.vue"),
        meta: {
            title: "业务规则",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/feedback",
        name: "feedback",
        component: () =>
            import(/* webpackChunkName: "feedback" */ "@/pages/help/feedback.vue"),
        meta: {
            title: "",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/complain",
        name: "complain",
        component: () =>
            import(/* webpackChunkName: "complain" */ "@/pages/help/complain.vue"),
        meta: {
            title: "",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/familarQuestion",
        name: "familarQuestion",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/help/familarQuestion.vue"),
        meta: {
            title: "常见问题列表",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/questionDetail",
        name: "questionDetail",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/help/questionDetail.vue"),
        meta: {
            title: "常见问题详情",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/newTeacher",
        name: "newTeacher",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/activity/teacherRecommend/newTeacher.vue"),
        meta: {
            title: "特惠专区",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: false,
        },
    },
    {
        path: "/famousTeacher",
        name: "famousTeacher",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/activity/teacherRecommend/famousTeacher.vue"),
        meta: {
            title: "知名大师",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: false,
        },
    },
    {
        path: "/wellKnownTeacher",
        name: "wellKnownTeacher",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/activity/teacherRecommend/wellKnownTeacher.vue"),
        meta: {
            title: "知名大咖",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: false,
        },
    },
    {
        path: "/voiceTeacher",
        name: "voiceTeacher",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/activity/teacherRecommend/voiceTeacher.vue"),
        meta: {
            title: "24H通话",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: false,
        },
    },
    {
        path: "/overseaVoiceTeacher",
        name: "overseaVoiceTeacher",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/activity/teacherRecommend/overseaVoiceTeacher.vue"),
        meta: {
            title: "24H通話",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: false,
        },
    },
    {
        path: "/voiceRec",
        name: "voiceRec",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/activity/teacherRecommend/voiceRec.vue"),
        meta: {
            title: "新人免费通话",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: false,
        },
    },
    {
        path: "/qualityTeacher",
        name: "qualityTeacher",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/activity/teacherRecommend/qualityTeacher.vue"),
        meta: {
            title: "精选服务",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: false,
        },
    },
    {
        path: "/teenagersNotice",
        name: "teenagersNoticePage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/teenagersNotice.vue"),
        meta: {
            title: "青少年模式须知",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/open_fm",
        name: "fmSharePage",
        component: () =>
            import(/* webpackChunkName: "fm" */ "@/pages/fm/share.vue"),
        meta: {
            title: "知屿",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/fmAlbum",
        name: "fmAlbumPage",
        component: () =>
            import(/* webpackChunkName: "fm" */ "@/pages/fm/fmAlbum.vue"),
        meta: {
            title: "知屿",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/yunshi",
        name: "yunshiPage",
        component: () =>
            import(/* webpackChunkName: "yunshi" */ "@/pages/yunshi/index.vue"),
        meta: {
            title: "运气",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: false,
            needLoginTz: true,
        },
    },
    {
        path: "/fmlist",
        name: "fmListPage",
        component: () =>
            import(/* webpackChunkName: "live" */ "@/pages/fm/fmList.vue"),
        meta: {
            title: "知屿FM",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    // {
    // 	path: "/2020taohua",
    // 	name: "2020taohua",
    // 	component: () => import(/* webpackChunkName: "fm" */ "@/pages/activity/2020taohua/index.vue"),
    // 	meta: {
    // 		title: "瓜分芝士",
    // 		keepAlive: false,
    // 		needLoginLjds: true,
    // 		needLoginTz: true,
    // 	},
    // },
    // {
    // 	path: "/taohuaReward",
    // 	name: "taohuaReward",
    // 	component: () => import(/* webpackChunkName: "fm" */ "@/pages/activity/2020taohua/rewardList.vue"),
    // 	meta: {
    // 		title: "知屿",
    // 		keepAlive: false,
    // 		needLoginLjds: true,
    // 		needLoginTz: true,
    // 	},
    // },
    // {
    // 	path: "/allEquity",
    // 	name: "allEquity",
    // 	component: () => import(/* webpackChunkName: "vip" */ "@/pages/vip/allEquity.vue"),
    // 	meta: {
    // 		title: "我的会员",
    // 		keepAlive: false,
    // 		needLoginTz: true,
    // 		needLoginLjds: true,
    // 	},
    // },
    // {
    // 	path: "/myVip",
    // 	name: "myVip",
    // 	component: () => import(/* webpackChunkName: "vip" */ "@/pages/vip/myVip.vue"),
    // 	meta: {
    // 		title: "我的会员",
    // 		keepAlive: false,
    // 		needLoginTz: true,
    // 		needLoginLjds: true,
    // 	},
    // },
    //商城
    {
        path: "/mall",
        name: "mall",
        component: () =>
            import(/* webpackChunkName: "vip" */ "@/pages/vip/mall.vue"),
        meta: {
            title: "积分商城",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/mallOrder",
        name: "mallOrder",
        component: () =>
            import(/* webpackChunkName: "vip" */ "@/pages/vip/mallOrder.vue"),
        meta: {
            title: "商城订单",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/exchangeHistory",
        name: "exchangeHistory",
        component: () =>
            import(/* webpackChunkName: "vip" */ "@/pages/vip/exchangeHistory.vue"),
        meta: {
            title: "积分兑换记录",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    // {
    // 	path: "/birthHistory",
    // 	name: "birthHistory",
    // 	component: () => import(/* webpackChunkName: "vip" */ "@/pages/vip/birthHistory.vue"),
    // 	meta: {
    // 		title: "兑换记录",
    // 		keepAlive: false,
    // 		needLoginTz: true,
    // 		needLoginLjds: true,
    // 	},
    // },
    // {
    // 	path: "/myEquity",
    // 	name: "myEquity",
    // 	component: () => import(/* webpackChunkName: "vip" */ "@/pages/vip/myEquity.vue"),
    // 	meta: {
    // 		title: "我的权益",
    // 		keepAlive: false,
    // 		needLoginTz: true,
    // 		needLoginLjds: true,
    // 	},
    // },
    // {
    // 	path: "/equitySystem",
    // 	name: "equitySystem",
    // 	component: () => import(/* webpackChunkName: "vip" */ "@/pages/vip/equitySystem.vue"),
    // 	meta: {
    // 		title: "等级权益制度",
    // 		keepAlive: false,
    // 		needLoginTz: true,
    // 		needLoginLjds: true,
    // 	},
    // },
    // {
    // 	path: "/vipEmail",
    // 	name: "vipEmail",
    // 	component: () => import(/* webpackChunkName: "vip" */ "@/pages/vip/vipEmail.vue"),
    // 	meta: {
    // 		title: "会员信箱",
    // 		keepAlive: false,
    // 		needLoginTz: true,
    // 		needLoginLjds: true,
    // 	},
    // },
    {
        path: "/confirmOrder",
        name: "confirmOrder",
        component: () =>
            import(/* webpackChunkName: "vip" */ "@/pages/vip/confirmOrder.vue"),
        meta: {
            title: "确认订单",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/confirmMallOrder",
        name: "confirmMallOrder",
        component: () =>
            import(/* webpackChunkName: "vip" */ "@/pages/vip/confirmMallOrder.vue"),
        meta: {
            title: "确认订单",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/orderSuccessful",
        name: "orderSuccessful",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/vip/orderSuccessful.vue"),
        meta: {
            title: "确认订单",
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/userAddress",
        name: "userAddress1",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/vip/userAddress.vue"),
        meta: {
            title: "用户地址",
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/goodDetail",
        name: "goodDetail",
        component: () =>
            import(/* webpackChunkName: "vip" */ "@/pages/vip/goodDetail.vue"),
        meta: {
            title: "商品详情",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/mallGoodDetail",
        name: "mallGoodDetail",
        component: () =>
            import(/* webpackChunkName: "vip" */ "@/pages/vip/mallGoodDetail.vue"),
        meta: {
            title: "商品详情",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/promotionList",
        name: "promotionListPage",
        component: () =>
            import(/* webpackChunkName: "promotion" */ "@/pages/teacher/promotion/center.vue"),
        meta: {
            title: "推广中心",
            keepAlive: true,
            needLoginLjds: false,
            needLoginYdk: true,
        },
    },
    {
        path: "/promotionRecord",
        name: "promotionRecordPage",
        component: () =>
            import(/* webpackChunkName: "promotion" */ "@/pages/teacher/promotion/record.vue"),
        meta: {
            title: "报名记录",
            keepAlive: true,
            needLoginLjds: false,
            needLoginYdk: true,
        },
    },
    {
        path: "/promotionDetail",
        name: "promotionDetailPage",
        component: () =>
            import(/* webpackChunkName: "promotion" */ "@/pages/teacher/promotion/detail.vue"),
        meta: {
            title: "推广详情",
            keepAlive: true,
            needLoginLjds: false,
            needLoginYdk: true,
        },
    },
    {
        path: "/courseIndex",
        name: "courseIndexPage",
        component: () =>
            import(/* webpackChunkName: "teacher" */ "@/pages/teacher/course/index.vue"),
        meta: {
            title: "知屿课程",
            keepAlive: true,
            needLoginLjds: false,
            needLoginYdk: true,
        },
    },
    {
        path: "/chapterList",
        name: "chapterListPage",
        component: () =>
            import(/* webpackChunkName: "teacher" */ "@/pages/teacher/course/chapter.vue"),
        meta: {
            title: "知屿课程",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: true,
        },
    },
    {
        path: "/chapterLearn",
        name: "chapterLearnPage",
        component: () =>
            import(/* webpackChunkName: "teacher" */ "@/pages/teacher/course/chapterLearn.vue"),
        meta: {
            title: "知屿课程",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: true,
        },
    },
    {
        path: "/exam",
        name: "examPage",
        component: () =>
            import(/* webpackChunkName: "teacher" */ "@/pages/teacher/course/exam.vue"),
        meta: {
            title: "知屿课程",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: true,
        },
    },
    {
        path: "/recommend",
        name: "recommendPage",
        component: () =>
            import(/* webpackChunkName: "teacher" */ "@/pages/teacher/recommend/index.vue"),
        meta: {
            title: "推荐有礼",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: true,
        },
    },
    {
        path: "/recommendRecord",
        name: "recommendRecordPage",
        component: () =>
            import(/* webpackChunkName: "teacher" */ "@/pages/teacher/recommend/recordList.vue"),
        meta: {
            title: "推荐记录详情",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: true,
        },
    },
    {
        path: "/recommendJoin",
        name: "recommendJoinPage",
        component: () =>
            import(/* webpackChunkName: "teacher" */ "@/pages/teacher/recommend/join.vue"),
        meta: {
            title: "推荐入驻",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: true,
        },
    },
    {
        path: "/consultantReport",
        name: "consultantReportPage",
        component: () =>
            import(/* webpackChunkName: "teacher" */ "@/pages/teacher/report/detail.vue"),
        meta: {
            title: "咨询报告",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/teacherRank",
        name: "teacherRankPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/teacherRank.vue"),
        meta: {
            title: "老师等级说明",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: true,
        },
    },
    {
        path: "/tzDownload",
        name: "tzDownloadPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/tzDownload.vue"),
        meta: {
            title: "知屿-陪伴你的抉择",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/qgDownload",
        name: "qgDownloadPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/qgDownload.vue"),
        meta: {
            title: "知屿-陪伴你的抉择",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/divination",
        name: "divinationPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/divination.vue"),
        meta: {
            title: "塔罗灵数计算机",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    // {  //2020  520活动
    //     path: '/2020valentine',
    //     name: '2020valentine',
    //     component: () => import( /* webpackChunkName: "static" */ '@/pages/activity/2020valentine/index.vue'),
    //     meta: {
    //         title: '520领取爱的礼物',
    //         keepAlive: false,
    //         needLoginTz: true,
    // 		needLoginLjds: true,
    //     }
    // },
    // {  //2020  520活动
    //     path: '/bindWechat',
    //     name: 'bindWechat',
    //     component: () => import( /* webpackChunkName: "static" */ '@/pages/activity/2020valentine/bind.vue'),
    //     meta: {
    //         title: '520领取爱的礼物',
    //         keepAlive: false,
    //         needLoginTz: true,
    // 		needLoginLjds: true,
    //     }
    // },
    {
        //暖心工具
        path: "/nuanxin",
        name: "nuanxin",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/nuanxin/index.vue"),
        meta: {
            title: "减压工具",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    {
        //暖心工具
        path: "/nxfocus",
        name: "nxfocus",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/nuanxin/focus.vue"),
        meta: {
            title: "减压工具",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        //暖心工具
        path: "/nxdetail",
        name: "nxdetail",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/nuanxin/detail.vue"),
        meta: {
            title: "减压工具",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        //暖心工具----冥想排行榜
        path: "/nxrank",
        name: "nxrank",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/nuanxin/rank.vue"),
        meta: {
            title: "减压工具",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/fansInvite",
        name: "fansInvitePage",
        component: () =>
            import(/* webpackChunkName: "group" */ "@/pages/group/invite.vue"),
        meta: {
            title: "粉丝群邀请函",
            keepAlive: false,
            needLoginLjds: true,
        },
    },
    {
        path: "/groupIntro",
        name: "groupIntroPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/groupIntro.vue"),
        meta: {
            title: "粉丝群介绍",
            keepAlive: false,
            needLoginLjds: true,
        },
    },
    {
        path: "/groupCreateNotes",
        name: "groupCreateNotesPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/groupCreateNotes.vue"),
        meta: {
            title: "创建粉丝群须知",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/groupUsers",
        name: "groupUsersPage",
        component: () =>
            import(/* webpackChunkName: "group" */ "@/pages/group/groupUsers.vue"),
        meta: {
            title: "群成员",
            keepAlive: false,
            needLoginLjds: true,
        },
    },
    {
        path: "/groupLottery",
        name: "groupLotteryPage",
        component: () =>
            import(/* webpackChunkName: "group" */ "@/pages/group/lottery.vue"),
        meta: {
            title: "",
            keepAlive: false,
            needLoginLjds: true,
        },
    },
    {
        path: "/gameplay",
        name: "gameplayPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/groupGameplay.vue"),
        meta: {
            title: "玩法介绍",
            keepAlive: false,
            needLoginLjds: true,
        },
    },
    // {  //2020  66周年庆活动
    //     path: '/2020anniversary',
    //     name: '2020anniversary',
    //     component: () => import( /* webpackChunkName: "activity" */ '@/pages/activity/2020anniversary/index.vue'),
    //     meta: {
    //         title: '周年庆',
    //         keepAlive: false,
    //         needLoginTz: true,
    // 		needLoginLjds: true,
    //     }
    // },
    {
        path: "/refund",
        name: "refundPage",
        component: () =>
            import(/* webpackChunkName: "newTaluo" */ "@/pages/activity/refund.vue"),
        meta: {
            title: "新人免费测算福利",
            keepAlive: false,
            needLoginTz: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/bdDownload",
        name: "bdDownloadPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/bdDownload.vue"),
        meta: {
            title: "知屿",
            keepAlive: false,
            needLoginTz: false,
            needLoginLjds: false,
        },
    },
    {
        //情感测评主页
        path: "/qgindex",
        name: "qgindex",
        component: () =>
            import(/* webpackChunkName: "qingganceping" */ "@/pages/qingganceping/index.vue"),
        meta: {
            title: "情感测评",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
            needLoginYdk: true,
            needSense: true,
        },
    },
    {
        //情感测评结果页
        path: "/qgresult",
        name: "qgresult",
        component: () =>
            import(/* webpackChunkName: "qingganceping" */ "@/pages/qingganceping/result.vue"),
        meta: {
            title: "情感测评",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/oepeDownload",
        name: "oepeDownloadPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/oepeDownload.vue"),
        meta: {
            title: "知屿-陪伴你的抉择",
            keepAlive: false,
            needLoginTz: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/oldAndNew",
        name: "oldAndNewPage",
        component: () =>
            import(/* webpackChunkName: "newTaluo" */ "@/pages/activity/oldAndNew/index.vue"),
        meta: {
            title: "塔罗免单测算",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/inviteShare",
        name: "inviteSharePage",
        component: () =>
            import(/* webpackChunkName: "newTaluo" */ "@/pages/activity/oldAndNew/share.vue"),
        meta: {
            title: "塔罗免单测算",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/explainService",
        name: "explainServicePage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/explainService.vue"),
        meta: {
            title: "【功能说明】高级服务创建要求",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/explainComment",
        name: "explainCommentPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/explainComment.vue"),
        meta: {
            title: "【功能说明】差评申诉审核标准",
            keepAlive: false,
            needLoginLjds: false,
        },
    },

    {
        path: "/explainCoupon",
        name: "explainCouponPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/explainCoupon.vue"),
        meta: {
            title: "【功能说明】老师优惠券使用说明",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/explainOnline",
        name: "explainOnlinePage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/explainOnline.vue"),
        meta: {
            title: "【功能】在线功能使用说明",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/explainOrders",
        name: "explainOrdersPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/explainOrders.vue"),
        meta: {
            title: "【功能】优先派单使用说明",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/huanjingfenxi",
        name: "huanjingfenxi",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/activity/huanjingfenxi/index.vue"),
        meta: {
            title: "环境分析",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/newComerGift",
        name: "newComerGift",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/activity/newComerGift/index.vue"),
        meta: {
            title: "新人礼包",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/newComerGiftV2",
        name: "newComerGiftV2",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/activity/newComerGift/indexV2.vue"),
        meta: {
            title: "新人礼包",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/newComerGiftV3",
        name: "newComerGiftV3",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/activity/newComerGift/indexV3.vue"),
        meta: {
            title: "新人礼包",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/taluo",
        name: "taluo",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/activity/taluoSign/taluo.vue"),
        meta: {
            title: "塔罗日签",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: false,
        },
    },
    {
        path: "/taluoResult",
        name: "taluoResult",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/activity/taluoSign/result.vue"),
        meta: {
            title: "塔罗日签",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/teacherCollege",
        name: "teacherCollegePage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/teacherCollege.vue"),
        meta: {
            title: "【功能】老师学院说明",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/teacherReply",
        name: "teacherReplyPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/teacherReply.vue"),
        meta: {
            title: "闪测回答要求与示例",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/monthData",
        name: "monthDataPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/monthData.vue"),
        meta: {
            title: "【功能】本月数据说明",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        //老师端--我的星级页面
        path: "/teachergrade",
        name: "teachergradePage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/teachergrade.vue"),
        meta: {
            title: "好评分",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: true,
        },
    },
    {
        //老师端--必读事项页面
        path: "/teacherrules",
        name: "teacherRules",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/teacherrules.vue"),
        meta: {
            title: "必读事项",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: false,
        },
    },
    {
        path: "/2020guoqing",
        name: "2020guoqing",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/activity/2020guoqing/index.vue"),
        meta: {
            title: "双节答题有礼",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/2020gqrank",
        name: "2020gqrank",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/activity/2020guoqing/rank.vue"),
        meta: {
            title: "活动排行",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/2020gqtask",
        name: "2020gqtask",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/activity/2020guoqing/task.vue"),
        meta: {
            title: "体力获取",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/2020gqresult",
        name: "2020gqresult",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/activity/2020guoqing/result.vue"),
        meta: {
            title: "答案解析",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/2020gqdetail",
        name: "2020gqdetail",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/activity/2020guoqing/detail.vue"),
        meta: {
            title: "兑换详情",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/2020gqaddress",
        name: "2020gqaddress",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/activity/2020guoqing/address.vue"),
        meta: {
            title: "兑换地址",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/2020gqquestion",
        name: "2020gqquestion",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/activity/2020guoqing/question.vue"),
        meta: {
            title: "答题中",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/gqingDownload",
        name: "gqingDownload",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/gqingDownload.vue"),
        meta: {
            title: "知屿-陪伴你的抉择",
            keepAlive: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/courseDetail",
        name: "courseDetailPage",
        component: () =>
            import(/* webpackChunkName: "group" */ "@/pages/group/course/detail.vue"),
        meta: {
            title: "课程详情",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/myExercise",
        name: "myExercisePage",
        component: () =>
            import(/* webpackChunkName: "group" */ "@/pages/group/course/exerciseList.vue"),
        meta: {
            title: "我的练习",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/exerciseExam",
        name: "exerciseExamPage",
        component: () =>
            import(/* webpackChunkName: "group" */ "@/pages/group/course/exam.vue"),
        meta: {
            title: "", // 我的练习考试
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/exerciseResult",
        name: "exerciseResultPage",
        component: () =>
            import(/* webpackChunkName: "group" */ "@/pages/group/course/exerciseResult.vue"),
        meta: {
            title: "", // 我的练习考试结果
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        // 问卷调查
        path: "/survey",
        name: "surveyPage",
        component: () =>
            import(/* webpackChunkName: "group" */ "@/pages/group/course/survey.vue"),
        meta: {
            title: "", // 我的练习考试结果
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/groupWelfare",
        name: "groupWelfarePage",
        component: () =>
            import(/* webpackChunkName: "group" */ "@/pages/group/welfare.vue"),
        meta: {
            title: "福利专区",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/surveyQuestion",
        name: "surveyQuestionPage",
        component: () =>
            import(/* webpackChunkName: "groupTeacher" */ "@/pages/group/course/surveyQuestion.vue"),
        meta: {
            title: "", // 某一个问卷调查问题列表，老师端页面
            keepAlive: false,
            needLoginYdk: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/surveyAnswer",
        name: "surveyAnswerPage",
        component: () =>
            import(/* webpackChunkName: "groupTeacher" */ "@/pages/group/course/surveyAnswer.vue"),
        meta: {
            title: "", // 某一个问卷调查某一个问题回答情况，老师端页面
            keepAlive: false,
            needLoginYdk: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/exerciseAnswer",
        name: "exerciseAnswerPage",
        component: () =>
            import(/* webpackChunkName: "groupTeacher" */ "@/pages/group/course/exerciseAnswer.vue"),
        meta: {
            title: "", // 某一个练习题回答情况，老师端页面
            keepAlive: false,
            needLoginYdk: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/userExercise",
        name: "userExercisePage",
        component: () =>
            import(/* webpackChunkName: "groupTeacher" */ "@/pages/group/course/userExercise.vue"),
        meta: {
            title: "", // 某一个用户某一个练习题回答情况，老师端页面
            keepAlive: false,
            needLoginYdk: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/applySuc",
        name: "applySucPage",
        component: () =>
            import(/* webpackChunkName: "group" */ "@/pages/group/course/applySuc.vue"),
        meta: {
            title: "付款成功", // 课程购买成功页面
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/courseHistory",
        name: "courseHistoryPage",
        component: () =>
            import(/* webpackChunkName: "group" */ "@/pages/group/course/history.vue"),
        meta: {
            title: "", // 课程社群历史消息
            keepAlive: true,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/historySearch",
        name: "historySearchPage",
        component: () =>
            import(/* webpackChunkName: "group" */ "@/pages/group/course/historySearch.vue"),
        meta: {
            title: "", // 课程社群历史消息搜索
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/serviceDetail",
        name: "serviceDetailPage",
        component: () =>
            import(/* webpackChunkName: "service" */ "@/pages/teacher/service/detail.vue"),
        meta: {
            title: "服务详情", // 高级服务详情
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/customDetail",
        name: "customDetailPage",
        component: () =>
            import(/* webpackChunkName: "service" */ "@/pages/teacher/service/custom.vue"),
        meta: {
            title: "服务详情", // 高价服务详情
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/customCate",
        name: "customCatePage",
        component: () =>
            import(/* webpackChunkName: "service" */ "@/pages/teacher/service/customCate.vue"),
        meta: {
            title: "服务详情", // 高价服务分类
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/recGoodsDetail",
        name: "recGoodsDetailPage",
        component: () =>
            import(/* webpackChunkName: "rec" */ "@/pages/teacher/report/recGoodsDetail.vue"),
        meta: {
            title: "", // 老师推荐商品详情
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/recGoodsOrder",
        name: "recGoodsOrderPage",
        component: () =>
            import(/* webpackChunkName: "rec" */ "@/pages/teacher/report/recGoodsOrder.vue"),
        meta: {
            title: "", // 老师推荐商品下单
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/testExplain",
        name: "testExplainPage",
        component: () =>
            import(/* webpackChunkName: "rec" */ "@/pages/static/testExplain.vue"),
        meta: {
            title: "内审说明",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: false,
        },
    },
    {
        path: "/reportExplain",
        name: "reportExplainPage",
        component: () =>
            import(/* webpackChunkName: "rec" */ "@/pages/static/reportExplain.vue"),
        meta: {
            title: "咨询报告使用说明",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: false,
        },
    },
    // 会员中心
    {
        path: "/newVip",
        name: "newVip",
        component: () =>
            import(/* webpackChunkName: "newVip" */ "@/pages/newVip/index.vue"),
        meta: {
            title: "会员中心",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    // 星座运势
    {
        path: "/xingzuoyunshi",
        name: "xingzuoyunshi",
        component: () =>
            import(/* webpackChunkName: "newVip" */ "@/pages/newVip/xingzuoyunshi.vue"),
        meta: {
            title: "星座运势",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    // 心经
    {
        path: "/xinjing",
        name: "xinjing",
        component: () =>
            import(/* webpackChunkName: "newVip" */ "@/pages/newVip/xinjing.vue"),
        meta: {
            title: "心经",
            keepAlive: false,
            needLoginTz: false,
            needLoginLjds: false,
        },
    },
    {
        path: "/newVip/experienceRecord",
        name: "experienceRecord",
        component: () =>
            import(/* webpackChunkName: "newVip" */ "@/pages/newVip/experienceRecord.vue"),
        meta: {
            title: "经验值明细",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/newVip/upgrade",
        name: "upgrade",
        component: () =>
            import(/* webpackChunkName: "newVip" */ "@/pages/newVip/upgrade.vue"),
        meta: {
            title: "升级攻略",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/newVip/equity",
        name: "equity",
        component: () =>
            import(/* webpackChunkName: "newVip" */ "@/pages/newVip/equity.vue"),
        meta: {
            title: "我的权益",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/ability",
        name: "abilityPage",
        component: () =>
            import(/* webpackChunkName: "teacher" */ "@/pages/teacher/ability/index.vue"),
        meta: {
            title: "直播能力详情",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/serviceInfo",
        name: "serviceInfoPage",
        component: () =>
            import(/* webpackChunkName: "teacher" */ "@/pages/teacher/service/serviceInfo.vue"),
        meta: {
            title: "服务详情",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    // 旧会员页面路由重定向start
    {
        path: "/myVip",
        redirect: "newVip",
    },
    {
        path: "/birthHistory",
        redirect: "newVip",
    },
    {
        path: "/myEquity",
        redirect: "newVip",
    },
    {
        path: "/equitySystem",
        redirect: "newVip",
    },
    {
        path: "/allEquity",
        redirect: "newVip",
    },
    {
        path: "/vipEmail",
        redirect: "newVip",
    },
    // 旧会员页面路由重定向end
    {
        path: "/complaint",
        name: "complaintPage",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/complaint.vue"),
        meta: {
            title: "投诉",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/refundv2",
        name: "refundv2Page",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/activity/refundv2.vue"),
        meta: {
            title: "",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/articleShare",
        name: "articleSharePage",
        component: () =>
            import(/* webpackChunkName: "article" */ "@/pages/article/detailShare.vue"),
        meta: {
            title: "",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/xmArticleShare",
        name: "xmArticleSharePage",
        component: () =>
            import(/* webpackChunkName: "article" */ "@/pages/article/xmDetailShare.vue"),
        meta: {
            title: "",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/unitary",
        name: "unitary",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/activity/newComerGift/unitary.vue"),
        meta: {
            title: "1元礼包",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/chatHistory",
        name: "chatHistory",
        component: () =>
            import(/* webpackChunkName: "chatroom" */ "@/pages/chatroom/history.vue"),
        meta: {
            title: "咨询记录",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/couponPre",
        name: "couponPre",
        component: () =>
            import(/* webpackChunkName: "coupon" */ "@/pages/teacher/coupon/prefecture.vue"),
        meta: {
            title: "优惠券专区",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/autonym",
        name: "autonym",
        component: () =>
            import(/* webpackChunkName: "autonym" */ "@/pages/user/autonym.vue"),
        meta: {
            title: "实名认证",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/dayRec",
        name: "dayRecPage",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/activity/dayRec.vue"),
        meta: {
            title: "每日推荐",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: false,
        },
    },
    {
        path: "/hepanReport",
        name: "hepanReport",
        component: () =>
            import(/* webpackChunkName: "activity" */ "@/pages/activity/hepan/report.vue"),
        meta: {
            title: "合盘详情",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: false,
        },
    },
    {
        path: '/xmHepan',
        name: 'xmHepan',
        component: () =>
            import(/* webpackChunkName: "activity" */ '@/pages/activity/xmHepan/report.vue'),
        meta: {
            title: '合盘结果',
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: false,
        },
    },
    {
        path: '/xmHepanInfo',
        name: 'xmHepanInfo',
        component: () =>
            import(/* webpackChunkName: "activity" */ '@/pages/activity/xmHepan/info.vue'),
        meta: {
            title: '合盘档案',
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: false,
        },
    },
    // svip会员中心
    {
        path: "/svip",
        name: "svip",
        component: () =>
            import(/* webpackChunkName: "svip" */ "@/pages/svip/index.vue"),
        meta: {
            title: "VIP会员",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    // svip会员中心权益
    {
        path: "/svip/equity",
        name: "svipEquity",
        component: () =>
            import(/* webpackChunkName: "svip" */ "@/pages/svip/equity.vue"),
        meta: {
            title: "VIP会员权益",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
        },
    },
    {
        path: "/advise",
        name: "advisePage",
        component: () =>
            import(/* webpackChunkName: "teacher" */ "@/pages/teacher/advise/index.vue"),
        meta: {
            title: "经营建议",
            keepAlive: false,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/logout/authorization",
        name: "authorization",
        component: () =>
            import(/* webpackChunkName: "logout" */ "@/pages/logout/authorization.vue"),
        meta: {
            title: "账户注销",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: false,
        },
    },
    {
        path: "/logout/confirm",
        name: "confirm",
        component: () =>
            import(/* webpackChunkName: "logout" */ "@/pages/logout/confirm.vue"),
        meta: {
            title: "账户注销",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: false,
        },
    },
    {
        path: "/paypalSuc",
        name: "paypalSuc",
        component: () =>
            import(/* webpackChunkName: "static" */ "@/pages/static/paypalSuc.vue"),
        meta: {
            title: "支付",
            keepAlive: false,
            needLoginLjds: false,
            needLoginYdk: false,
        },
    },
    {
        path: "/couponRecommend",
        name: "couponRecommend",
        component: () =>
            import(/* webpackChunkName: "coupon" */ "@/pages/teacher/recommend/coupon.vue"),
        meta: {
            title: "优惠券",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
    {
        path: "/goodsRecommend",
        name: "goodsRecommend",
        component: () =>
            import(/* webpackChunkName: "goods" */ "@/pages/teacher/recommend/goods.vue"),
        meta: {
            title: "推荐商品",
            keepAlive: false,
            needLoginTz: true,
            needLoginLjds: true,
            needLoginYdk: true,
        },
    },
];
